module.exports = __webpack_public_path__ + "img/104ne.d0df4e27.svg";